import { PasswordStrength, User, UserData } from "../../entities/entities";
import { AuthenticationUseCases } from "../../domain";
import { authenticationRepository } from "../../../infrastructure/repository/impl/authentication_repository";

class _AuthenticationUseCases implements AuthenticationUseCases {
  async login(user: User): Promise<boolean> {
    return await authenticationRepository.login(user);
  }

  async finishOnBoarding(user: User): Promise<void> {
    return await authenticationRepository.finishOnBoarding(user);
  }

  async logout(): Promise<void> {
    await authenticationRepository.logout();
  }

  async register(user: User): Promise<void> {
    await authenticationRepository.register(user);
  }

  async getUserType(): Promise<number> {
    let userType: number = 1;

    const isAdmin = await authenticationRepository.getIsAdmin();
    if (isAdmin) {
      userType = 2;
    } else {
      const isManager = await authenticationRepository.getIsManager();
      if (isManager) {
        userType = 4;
      }
    }

    return userType;
  }

  async checkUserCredentials(userData: UserData): Promise<string> {
    return await authenticationRepository.checkUserCredentials(userData);
  }

  async changePassword(password: string, confirmation: string): Promise<void> {
    return await authenticationRepository.changePassword(
      password,
      confirmation
    );
  }

  async recoverPassword(
    login: string
  ): Promise<{ recoveryType: string; document: string }> {
    return await authenticationRepository.recoverPassword(login);
  }

  async recoverPasswordByEmail(
    login: string
  ): Promise<{ recoveryType: string; document: string }> {
    return await authenticationRepository.recoverPasswordByEmail(login);
  }

  async resetPasswordByEmail(
    password: string,
    confirmation: string,
    token: string
  ): Promise<void> {
    await authenticationRepository.resetPasswordByEmail(
      password,
      confirmation,
      token
    );
  }

  async resetPasswordByData(
    password: string,
    confirmation: string,
    token: string
  ): Promise<void> {
    await authenticationRepository.resetPasswordByData(
      password,
      confirmation,
      token
    );
  }

  async validatePasswordStrength(password: string): Promise<PasswordStrength> {
    return await authenticationRepository.validatePasswordStrength(password);
  }

  async acceptTerm(): Promise<void> {
    return await authenticationRepository.acceptTerm();
  }
}

export const authenticationUseCases: AuthenticationUseCases = new _AuthenticationUseCases();
